import React, { ReactNode } from 'react';
import { setupCameraControls } from '../CameraControls/CameraControls';
import { Themed } from '../Themed/Themed';

setupCameraControls();

export const AppProvider = ({ children }: { children: ReactNode }) => <Themed mode='underground'>{children}</Themed>;
